import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Conductor } from "src/app/shared/models/vehiculos/conductor";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConductoresService {
  constructor(private http: HttpClient) {}

  getAll(query:any = []):Observable<any> {
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "transporterId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http.get(`${environment.apiUrl}/transporte/conductores/lista?${queryBuid}`, {
      headers: headers,
    });
  }

  getAllAsync(query:any = []) :Promise<any>{
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "transporterId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/transporte/conductores/lista?${queryBuid}`, {
          headers: headers,
        })
        .subscribe({
          next: (data:any) => resolve(data.list),
          error: (err) => reject(err),
        });
    });
  }

  createConductor(data: Conductor) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .post(`${environment.apiUrl}/transporte/conductores/nuevo`, data, {
        headers: headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deshabilitarConductor(id: string) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .post(
        `${environment.apiUrl}/transporte/conductores/desactivar/${id}`,
        {},
        { headers: headers }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }


  habilitarConductor(id: string) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .post(
        `${environment.apiUrl}/transporte/conductores/activar/${id}`,
        {},
        { headers: headers }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getById(id: string) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(`${environment.apiUrl}/transporte/conductores/buscar/${id}`, {
        headers: headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  updateConductor(data: Conductor) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .post(`${environment.apiUrl}/transporte/conductores/guardar`, data, {
        headers: headers,
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
